import store from "../index.js";

export const isLoading = (value = true) => {
  store.commit("setIsLoading", value);
};
